import { atom } from 'jotai';
export const $PSM = atom('');
$PSM.debugLabel = '$PSM';
